import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = ["src"]
const _hoisted_2 = ["onClick", "index"]
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "text-theme-gray-2" }
const _hoisted_5 = { class: "text-theme-gray-2 font-light" }

import { ref, computed, onMounted, onUnmounted } from 'vue'
import Country from '@/composables/Country'

interface CountryType {
   id: number;
   name: string;
   flag: string;
   code: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'CountrySearchablePhoneField',
  props: ['class', 'sleek'],
  emits: ['phoneNumber', 'number'],
  setup(__props, { emit: __emit }) {

const props = __props
const emit = __emit
const { countriesList, getUserCountry } = Country()
const dropdownWrapper = ref()
const phoneNumber = ref<string>('')
const countries = ref({
   open: false,
   search: '',
   list: [] as CountryType[]
})

const fillteredCountryList = computed(() => {
   return countries.value.list.filter((country: CountryType) => country.name.toLowerCase().includes(countries.value.search)) as CountryType[];
})

const selectedCountry = ref<CountryType| null>(null)

const toggleCountryList = () => {
   countries.value.open = !countries.value.open
   countries.value.search = ''
}

const handleCountrySelect = (country: any) => {
   selectedCountry.value = country
   countries.value.open = false
}

const handleCountrySearch = (event:any) => {
   const input = event.target.value.toLowerCase()
   countries.value.search = input
}

const handlePhoneNumberInput = (event: any) => {
   phoneNumber.value = event.target.value.replace(/\D/g, '')

   if (phoneNumber.value.length > 10) {
      phoneNumber.value = phoneNumber.value.toString().slice(0, 10)
   }

   if (phoneNumber.value.length) {
      emit('phoneNumber', selectedCountry.value?.code + phoneNumber.value)
   } else {
      emit('phoneNumber', false)
   }
}

const handleClickOutside = (event: any) => {
   
   if (dropdownWrapper.value && !dropdownWrapper.value.contains(event.target as Node)) {
      countries.value.open = false
      countries.value.search = ''
   }
}

onMounted(async () => {
   const response = await countriesList()

    const fallbackCountries = [
       { id: 1, name: "Afghanistan", flag: "af", code: "93" },
       { id: 2, name: "Albania", flag: "al", code: "355" },
       { id: 3, name: "Algeria", flag: "dz", code: "213" },
       { id: 4, name: "Andorra", flag: "ad", code: "376" },
       { id: 5, name: "Angola", flag: "ao", code: "244" },
       { id: 6, name: "Antigua and Barbuda", flag: "ag", code: "1268" },
       { id: 7, name: "Argentina", flag: "ar", code: "54" },
       { id: 8, name: "Armenia", flag: "am", code: "374" },
       { id: 9, name: "Australia", flag: "au", code: "61" },
       { id: 10, name: "Austria", flag: "at", code: "43" },
       { id: 11, name: "Azerbaijan", flag: "az", code: "994" },
       { id: 12, name: "Bahamas", flag: "bs", code: "1242" },
       { id: 13, name: "Bahrain", flag: "bh", code: "973" },
       { id: 14, name: "Bangladesh", flag: "bd", code: "880" },
       { id: 15, name: "Barbados", flag: "bb", code: "1246" },
       { id: 16, name: "Belarus", flag: "by", code: "375" },
       { id: 17, name: "Belgium", flag: "be", code: "32" },
       { id: 18, name: "Belize", flag: "bz", code: "501" },
       { id: 19, name: "Benin", flag: "bj", code: "229" },
       { id: 20, name: "Bhutan", flag: "bt", code: "975" },
       { id: 21, name: "Bolivia", flag: "bo", code: "591" },
       { id: 22, name: "Bosnia and Herzegovina", flag: "ba", code: "387" },
       { id: 23, name: "Botswana", flag: "bw", code: "267" },
       { id: 24, name: "Brazil", flag: "br", code: "55" },
       { id: 25, name: "Brunei", flag: "bn", code: "673" },
       { id: 26, name: "Bulgaria", flag: "bg", code: "359" },
       { id: 27, name: "Burkina Faso", flag: "bf", code: "226" },
       { id: 28, name: "Burundi", flag: "bi", code: "257" },
       { id: 29, name: "Cambodia", flag: "kh", code: "855" },
       { id: 30, name: "Cameroon", flag: "cm", code: "237" },
       { id: 31, name: "Canada", flag: "ca", code: "1" },
       { id: 32, name: "Cape Verde", flag: "cv", code: "238" },
       { id: 33, name: "Central African Republic", flag: "cf", code: "236" },
       { id: 34, name: "Chad", flag: "td", code: "235" },
       { id: 35, name: "Chile", flag: "cl", code: "56" },
       { id: 36, name: "China", flag: "cn", code: "86" },
       { id: 37, name: "Colombia", flag: "co", code: "57" },
       { id: 38, name: "Comoros", flag: "km", code: "269" },
       { id: 39, name: "Congo", flag: "cg", code: "242" },
       { id: 40, name: "Costa Rica", flag: "cr", code: "506" },
       { id: 41, name: "Croatia", flag: "hr", code: "385" },
       { id: 42, name: "Cuba", flag: "cu", code: "53" },
       { id: 43, name: "Cyprus", flag: "cy", code: "357" },
       { id: 44, name: "Czech Republic", flag: "cz", code: "420" },
       { id: 45, name: "Denmark", flag: "dk", code: "45" },
       { id: 46, name: "Djibouti", flag: "dj", code: "253" },
       { id: 47, name: "Dominica", flag: "dm", code: "1767" },
       { id: 48, name: "Dominican Republic", flag: "do", code: "1809" },
       { id: 49, name: "Ecuador", flag: "ec", code: "593" },
       { id: 50, name: "Egypt", flag: "eg", code: "20" },
       { id: 51, name: "El Salvador", flag: "sv", code: "503" },
       { id: 52, name: "Equatorial Guinea", flag: "gq", code: "240" },
       { id: 53, name: "Eritrea", flag: "er", code: "291" },
       { id: 54, name: "Estonia", flag: "ee", code: "372" },
       { id: 55, name: "Ethiopia", flag: "et", code: "251" },
       { id: 56, name: "Fiji", flag: "fj", code: "679" },
       { id: 57, name: "Finland", flag: "fi", code: "358" },
       { id: 58, name: "France", flag: "fr", code: "33" },
       { id: 59, name: "Gabon", flag: "ga", code: "241" },
       { id: 60, name: "Gambia", flag: "gm", code: "220" },
       { id: 61, name: "Georgia", flag: "ge", code: "995" },
       { id: 62, name: "Germany", flag: "de", code: "49" },
       { id: 63, name: "Ghana", flag: "gh", code: "233" },
       { id: 64, name: "Greece", flag: "gr", code: "30" },
       { id: 65, name: "Grenada", flag: "gd", code: "1473" },
       { id: 66, name: "Guatemala", flag: "gt", code: "502" },
       { id: 67, name: "Guinea", flag: "gn", code: "224" },
       { id: 68, name: "Guinea-Bissau", flag: "gw", code: "245" },
       { id: 69, name: "Guyana", flag: "gy", code: "592" },
       { id: 70, name: "Haiti", flag: "ht", code: "509" },
       { id: 71, name: "Honduras", flag: "hn", code: "504" },
       { id: 72, name: "Hungary", flag: "hu", code: "36" },
       { id: 73, name: "Iceland", flag: "is", code: "354" },
       { id: 74, name: "India", flag: "in", code: "91" },
       { id: 75, name: "Indonesia", flag: "id", code: "62" },
       { id: 76, name: "Iran", flag: "ir", code: "98" },
       { id: 77, name: "Iraq", flag: "iq", code: "964" },
       { id: 78, name: "Ireland", flag: "ie", code: "353" },
       { id: 79, name: "Israel", flag: "il", code: "972" },
       { id: 80, name: "Italy", flag: "it", code: "39" },
       { id: 81, name: "Ivory Coast", flag: "ci", code: "225" },
       { id: 82, name: "Jamaica", flag: "jm", code: "1876" },
       { id: 83, name: "Japan", flag: "jp", code: "81" },
       { id: 84, name: "Jordan", flag: "jo", code: "962" },
       { id: 85, name: "Kazakhstan", flag: "kz", code: "7" },
       { id: 86, name: "Kenya", flag: "ke", code: "254" },
       { id: 87, name: "Kiribati", flag: "ki", code: "686" },
       { id: 88, name: "Kuwait", flag: "kw", code: "965" },
       { id: 89, name: "Kyrgyzstan", flag: "kg", code: "996" },
       { id: 90, name: "Laos", flag: "la", code: "856" },
       { id: 91, name: "Latvia", flag: "lv", code: "371" },
       { id: 92, name: "Lebanon", flag: "lb", code: "961" },
       { id: 93, name: "Lesotho", flag: "ls", code: "266" },
       { id: 94, name: "Liberia", flag: "lr", code: "231" },
       { id: 95, name: "Libya", flag: "ly", code: "218" },
       { id: 96, name: "Liechtenstein", flag: "li", code: "423" },
       { id: 97, name: "Lithuania", flag: "lt", code: "370" },
       { id: 98, name: "Luxembourg", flag: "lu", code: "352" },
       { id: 99, name: "Madagascar", flag: "mg", code: "261" },
       { id: 100, name: "Malawi", flag: "mw", code: "265" },
       { id: 101, name: "Malaysia", flag: "my", code: "60" },
       { id: 102, name: "Maldives", flag: "mv", code: "960" },
       { id: 103, name: "Mali", flag: "ml", code: "223" },
       { id: 104, name: "Malta", flag: "mt", code: "356" },
       { id: 105, name: "Marshall Islands", flag: "mh", code: "692" },
       { id: 106, name: "Mauritania", flag: "mr", code: "222" },
       { id: 107, name: "Mauritius", flag: "mu", code: "230" },
       { id: 108, name: "Mexico", flag: "mx", code: "52" },
       { id: 109, name: "Micronesia", flag: "fm", code: "691" },
       { id: 110, name: "Moldova", flag: "md", code: "373" },
       { id: 111, name: "Monaco", flag: "mc", code: "377" },
       { id: 112, name: "Mongolia", flag: "mn", code: "976" },
       { id: 113, name: "Montenegro", flag: "me", code: "382" },
       { id: 114, name: "Morocco", flag: "ma", code: "212" },
       { id: 115, name: "Mozambique", flag: "mz", code: "258" },
       { id: 116, name: "Myanmar", flag: "mm", code: "95" },
       { id: 117, name: "Namibia", flag: "na", code: "264" },
       { id: 118, name: "Nauru", flag: "nr", code: "674" },
       { id: 119, name: "Nepal", flag: "np", code: "977" },
       { id: 120, name: "Netherlands", flag: "nl", code: "31" },
       { id: 121, name: "New Zealand", flag: "nz", code: "64" },
       { id: 122, name: "Nicaragua", flag: "ni", code: "505" },
       { id: 123, name: "Niger", flag: "ne", code: "227" },
       { id: 124, name: "Nigeria", flag: "ng", code: "234" },
       { id: 125, name: "North Korea", flag: "kp", code: "850" },
       { id: 126, name: "North Macedonia", flag: "mk", code: "389" },
       { id: 127, name: "Norway", flag: "no", code: "47" },
       { id: 128, name: "Oman", flag: "om", code: "968" },
       { id: 129, name: "Pakistan", flag: "pk", code: "92" },
       { id: 130, name: "Palau", flag: "pw", code: "680" },
       { id: 131, name: "Palestine", flag: "ps", code: "970" },
       { id: 132, name: "Panama", flag: "pa", code: "507" },
       { id: 133, name: "Papua New Guinea", flag: "pg", code: "675" },
       { id: 134, name: "Paraguay", flag: "py", code: "595" },
       { id: 135, name: "Peru", flag: "pe", code: "51" },
       { id: 136, name: "Philippines", flag: "ph", code: "63" },
       { id: 137, name: "Poland", flag: "pl", code: "48" },
       { id: 138, name: "Portugal", flag: "pt", code: "351" },
       { id: 139, name: "Qatar", flag: "qa", code: "974" },
       { id: 140, name: "Romania", flag: "ro", code: "40" },
       { id: 141, name: "Russia", flag: "ru", code: "7" },
       { id: 142, name: "Rwanda", flag: "rw", code: "250" },
       { id: 143, name: "Saint Kitts and Nevis", flag: "kn", code: "1869" },
       { id: 144, name: "Saint Lucia", flag: "lc", code: "1758" },
       { id: 145, name: "Saint Vincent and the Grenadines", flag: "vc", code: "1784" },
       { id: 146, name: "Samoa", flag: "ws", code: "685" },
       { id: 147, name: "San Marino", flag: "sm", code: "378" },
       { id: 148, name: "Sao Tome and Principe", flag: "st", code: "239" },
       { id: 149, name: "Saudi Arabia", flag: "sa", code: "966" },
       { id: 150, name: "Senegal", flag: "sn", code: "221" },
       { id: 151, name: "Serbia", flag: "rs", code: "381" },
       { id: 152, name: "Seychelles", flag: "sc", code: "248" },
       { id: 153, name: "Sierra Leone", flag: "sl", code: "232" },
       { id: 154, name: "Singapore", flag: "sg", code: "65" },
       { id: 155, name: "Slovakia", flag: "sk", code: "421" },
       { id: 156, name: "Slovenia", flag: "si", code: "386" },
       { id: 157, name: "Solomon Islands", flag: "sb", code: "677" },
       { id: 158, name: "Somalia", flag: "so", code: "252" },
       { id: 159, name: "South Africa", flag: "za", code: "27" },
       { id: 160, name: "South Korea", flag: "kr", code: "82" },
       { id: 161, name: "South Sudan", flag: "ss", code: "211" },
       { id: 162, name: "Spain", flag: "es", code: "34" },
       { id: 163, name: "Sri Lanka", flag: "lk", code: "94" },
       { id: 164, name: "Sudan", flag: "sd", code: "249" },
       { id: 165, name: "Suriname", flag: "sr", code: "597" },
       { id: 166, name: "Swaziland", flag: "sz", code: "268" },
       { id: 167, name: "Sweden", flag: "se", code: "46" },
       { id: 168, name: "Switzerland", flag: "ch", code: "41" },
       { id: 169, name: "Syria", flag: "sy", code: "963" },
       { id: 170, name: "Taiwan", flag: "tw", code: "886" },
       { id: 171, name: "Tajikistan", flag: "tj", code: "992" },
       { id: 172, name: "Tanzania", flag: "tz", code: "255" },
       { id: 173, name: "Thailand", flag: "th", code: "66" },
       { id: 174, name: "Timor-Leste", flag: "tl", code: "670" },
       { id: 175, name: "Togo", flag: "tg", code: "228" },
       { id: 176, name: "Tonga", flag: "to", code: "676" },
       { id: 177, name: "Trinidad and Tobago", flag: "tt", code: "1868" },
       { id: 178, name: "Tunisia", flag: "tn", code: "216" },
       { id: 179, name: "Turkey", flag: "tr", code: "90" },
       { id: 180, name: "Turkmenistan", flag: "tm", code: "993" },
       { id: 181, name: "Tuvalu", flag: "tv", code: "688" },
       { id: 182, name: "Uganda", flag: "ug", code: "256" },
       { id: 183, name: "Ukraine", flag: "ua", code: "380" },
       { id: 184, name: "United Arab Emirates", flag: "ae", code: "971" },
       { id: 185, name: "United Kingdom", flag: "gb", code: "44" },
       { id: 186, name: "United States", flag: "us", code: "1" },
       { id: 187, name: "Uruguay", flag: "uy", code: "598" },
       { id: 188, name: "Uzbekistan", flag: "uz", code: "998" },
       { id: 189, name: "Vanuatu", flag: "vu", code: "678" },
       { id: 190, name: "Vatican City", flag: "va", code: "379" },
       { id: 191, name: "Venezuela", flag: "ve", code: "58" },
       { id: 192, name: "Vietnam", flag: "vn", code: "84" },
       { id: 193, name: "Yemen", flag: "ye", code: "967" },
       { id: 194, name: "Zambia", flag: "zm", code: "260" },
       { id: 195, name: "Zimbabwe", flag: "zw", code: "263" }
    ]

   if (response.status == 200 && response.data?.data?.length > 0) {
      countries.value.list = response.data.data
   } else {
      countries.value.list = fallbackCountries
   }

   const currentCountry = await getUserCountry()
   if (currentCountry?.status == 200 && currentCountry.data?.country) {
      selectedCountry.value = currentCountry.data.country
   } else {
      // Fallback to Bahrain (+973) if detection fails
      selectedCountry.value = countries.value.list.find((c: any) => c.code === '973') || countries.value.list[0] || null
   }

   document.addEventListener('click', handleClickOutside);
})

onUnmounted(() => {
   document.removeEventListener('click', handleClickOutside);
})


return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", {
    ref_key: "dropdownWrapper",
    ref: dropdownWrapper,
    class: "relative"
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["flex flex-row items-center gap-2 w-full bg-white", __props.class])
    }, [
      _createElementVNode("div", {
        onClick: toggleCountryList,
        class: "flex flex-row items-center gap-2 cursor-pointer"
      }, [
        _createElementVNode("span", null, [
          (selectedCountry.value?.flag)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                class: "min-w-[20px] max-w-[20px]",
                src: `/assets/flags/${selectedCountry.value.flag.toLowerCase()}.svg`,
                alt: `flag`,
                onError: _cache[0] || (_cache[0] = (e) => e.target.style.display = 'none')
              }, null, 40, _hoisted_1))
            : _createCommentVNode("", true)
        ]),
        (selectedCountry.value)
          ? (_openBlock(), _createElementBlock("span", {
              key: 0,
              class: _normalizeClass(__props.sleek ? 'text-sm' : '')
            }, "+" + _toDisplayString(selectedCountry.value.code), 3))
          : _createCommentVNode("", true),
        _createElementVNode("span", null, [
          _createVNode(_component_font_awesome_icon, {
            size: "sm",
            icon: "fa-solid fa-chevron-down",
            class: "text-theme-active"
          })
        ])
      ]),
      _withDirectives(_createElementVNode("input", {
        onInput: handlePhoneNumberInput,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((phoneNumber).value = $event)),
        placeholder: "Enter phone number",
        type: "text",
        class: _normalizeClass([__props.sleek ? 'text-sm' : '', "outline-none w-full h-30 font-bold text-size-6 border-none w-full bg-transparent"])
      }, null, 34), [
        [_vModelText, phoneNumber.value]
      ])
    ], 2),
    (countries.value.open)
      ? (_openBlock(), _createElementBlock("ul", {
          key: 0,
          onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"])),
          class: "z-50 max-h-[200px] overflow-y-auto top-full absolute right-0 p-4 flex flex-col gap-2 w-full shadow-lg bg-white ring-1 ring-black ring-opacity-5"
        }, [
          _createElementVNode("li", null, [
            _createElementVNode("input", {
              class: "w-full border bordet-theme-gray-7 text-size-4 text-gray-5 outline-none px-2 py-1",
              placeholder: "Search country",
              type: "text",
              onInput: handleCountrySearch
            }, null, 32)
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(fillteredCountryList.value, (country) => {
            return (_openBlock(), _createElementBlock("li", {
              onClick: ($event: any) => (handleCountrySelect(country)),
              index: country.id,
              class: "flex flex-row items-center gap-3 cursor-pointer hover:bg-gray-100 p-1"
            }, [
              _createElementVNode("img", {
                class: "min-w-[20px] max-w-[20px]",
                src: `/assets/flags/${country.flag.toLowerCase()}.svg`,
                alt: "sweden flag"
              }, null, 8, _hoisted_3),
              _createElementVNode("span", _hoisted_4, _toDisplayString(country.name), 1),
              _createElementVNode("span", _hoisted_5, "+" + _toDisplayString(country.code), 1)
            ], 8, _hoisted_2))
          }), 256))
        ]))
      : _createCommentVNode("", true)
  ], 512))
}
}

})